import React from 'react';
import cls from 'classnames';

function DefaultContentWrapper({ clsn, padding, children }) {
  const className = cls(
    clsn,
    padding || "px-6 pb-10 pt-12 md:py-12 md:mx-auto",
    "flex flex-col md:w-[700px] lg:w-[744px]",
  );

  return <div className={className}>{children}</div>;
}
const HeaderTitle = ({ children }) => {
  return <h1 className="!text-white my-0 font-medium !text-[2.5rem] !leading-[3rem] relative ">{children}</h1>;
};


export const ContentfulHeader = ({
  sub_title = undefined,
  title ,
  desc = '',
  note = undefined,
  children =  null,
  clsn= "",
  wrapper ="",
  contentWrapper: ContentWrapper = DefaultContentWrapper,
  padding,
  sidebar = undefined,

}) => {
  return (
    <div
      className={cls(
        "header bg-is2-blue text-white relative",
      
        wrapper,
        clsn
      )}
      data-testid="area-header"
    >
      <ComponentOrElement
        as={ContentWrapper}
        clsn={clsn}
        sidebar={sidebar}
        padding={padding}
      >
        {sub_title && <p className="text-is2-blue-100">{sub_title}</p>}

        {title && (
          <HeaderTitle>
            {title}
          </HeaderTitle>
        )}

        {desc && <p className="text-is2-blue-100 mb-5 mt-3">{desc}</p>}

        {children}

        {note && <p className="text-sm text-[#99C1FA] mt-3">{note}</p>}
      </ComponentOrElement>
    </div>
  );
};

function ComponentOrElement({ as: C, ...props }) {
  return React.isValidElement(C) ? (
    React.cloneElement(C, props)
  ) : (
    <C {...props} />
  );
}
